import { render, staticRenderFns } from "./reducePrincipal.vue?vue&type=template&id=b9a33954&scoped=true&"
import script from "./reducePrincipal.vue?vue&type=script&lang=ts&"
export * from "./reducePrincipal.vue?vue&type=script&lang=ts&"
import style0 from "./reducePrincipal.vue?vue&type=style&index=0&id=b9a33954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a33954",
  null
  
)

export default component.exports